export const InfoColor = '#0289d1';
export const PrimaryColor = '#1977d3';
export const SuccessColor = '#2e7d33';
export const ErrorColor = '#d3302f';
export const WarningColor = '#ed6c03';
